export var MethodologyChangelogInclude = {
    methodologyChangelogGlobal: true,
    activityDataSource: true,
    subcategory: {
        include: {
            category: {
                include: {
                    image: true,
                },
            },
        },
    },
};
//# sourceMappingURL=MethodologyChangelog.js.map